import { Share2 } from 'lucide-react';
import { toast } from 'sonner';
import { cn } from '@/lib/utils';
import { trackEvent } from '@/lib/analytics';

interface ShareButtonProps {
  mode: 'exam' | 'score';
  examName: string;
  examId: string;
  score?: number;
  className?: string;
}

export function ShareButton({ mode, examName, examId, score, className }: ShareButtonProps) {
  const handleShare = async () => {
    const url = `${window.location.origin}/exam/${examId}`;
    const text = mode === 'score'
      ? `J'ai obtenu ${score}% sur ${examName} sur Exam Copilot ! 🎓 Testez-vous aussi :`
      : `Découvrez ${examName} sur Exam Copilot ! Préparez vos examens gratuitement 🎓`;

    trackEvent('share', {
      method: typeof navigator.share === 'function' ? 'native' : 'clipboard',
      content_type: mode === 'score' ? 'score' : 'exam',
      item_id: examId,
    });

    if (navigator.share) {
      try {
        await navigator.share({ title: `Exam Copilot — ${examName}`, text, url });
      } catch {
        // user cancelled
      }
    } else {
      await navigator.clipboard.writeText(`${text}\n${url}`);
      toast.success('Lien copié !');
    }
  };

  return (
    <button
      onClick={handleShare}
      className={cn(
        'flex items-center gap-1.5 px-2.5 py-1.5 bg-overlay-1 border border-line rounded-lg text-fg-subtle hover:text-fg-muted hover:bg-overlay-2 transition-colors',
        className
      )}
    >
      <Share2 className="w-3.5 h-3.5" />
      <span className="text-[10px] sm:text-xs font-medium">Partager</span>
    </button>
  );
}
